import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App, { SentryRoutes } from "./app";
import "./assets/stylesheets/native.css";
import { BrowserRouter, Navigate, Route } from "react-router";
import { isSupported, apply } from "invokers-polyfill/fn";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

if (!isSupported()) apply();

const root = document.getElementById("root");

const appHeight = () => {
  root.style.setProperty("--app-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", appHeight);
window.addEventListener("blur", appHeight);
appHeight();

ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <SentryRoutes>
      <Route path="/" element={<Navigate to={"/nl"} />} />
      <Route path="/nl/*" element={<App root={root} locale={"nl"} />} />
      <Route path="/fr/*" element={<App root={root} locale={"fr"} />} />
      <Route path="/de/*" element={<App root={root} locale={"de"} />} />
    </SentryRoutes>
  </BrowserRouter>,
);
